import configServices from "./configServices";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  message: "",
  isError: false,
  isSuccess: false,
  isLoading: false,
  university_designation: null,
};

export const getConfigDetails = createAsyncThunk(
  "config/getConfig",
  async (params, thunkAPI) => {
    try {
      return await configServices.getConfigDetails(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateConfigDetail = createAsyncThunk(
  "config/updateConfig",
  async (params, thunkAPI) => {
    try {
      return await configServices.updateConfigDetail(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getConfigDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getConfigDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getConfigDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.university_designation = action.payload.data.filter(
          (item) => item.configuration_type === "university_designation"
        );
      })
      .addCase(updateConfigDetail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateConfigDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateConfigDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
      });
  },
});
export default configSlice.reducer;
